const imageHeight = 50;

export default [
  {
    margin: [0, 20, 0, 20],
    columns: [
      { width: "*", text: "" },
      {
        width: "auto",
        stack: [
          {
            image: "air",
            width: (imageHeight / 145) * 616,
          },
        ],
      },
      {
        text: null,
        width: 30,
      },
      {
        width: "auto",
        stack: [
          {
            image: "fng",
            width: ((imageHeight + 5) / 166) * 166,
          },
        ],
      },
      {
        text: null,
        width: "*",
      },
      {
        width: "auto",
        stack: [
          {
            image: "first",
            width: ((imageHeight + 10) / 185) * 284,
          },
        ],
      },
      { width: "*", text: "" },
    ],
  },
];
